// extracted by mini-css-extract-plugin
export var cartIcon = "_mr-0";
export var cartIconContainer = "_mr-1";